export default __webpack_public_path__ + "static/media/bill-gates.4f713420.jpeg";